module.exports = __webpack_public_path__ + "static/img/PG.8ba51169.svg";